export const DOMAIN_REGEX = /^[a-z-]+$/i;
export const PHONE_REGEX = /^\d{3}-\d{3}-\d{4}$/;
export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;